import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { DataLayerErrorType } from 'app/data-layers/model/data-layer-error-type';
import { selectSelectedAccount, selectShoppingCart } from 'app/pages/order/redux/order-selector';
import { selectIsAuthenticated } from 'app/pages/auth/redux/auth-selectors';
import { pushErrorEvent } from 'app/data-layers/events/push-error-event';

export const useErrorDataLayer = (dataLayerErrorType: DataLayerErrorType) => {
    const isLoggedIn = useSelector(selectIsAuthenticated);
    const selectedAccount = useSelector(selectSelectedAccount);
    const shoppingCart = useSelector(selectShoppingCart);

    useEffect(() => {
        pushErrorEvent(
            isLoggedIn,
            dataLayerErrorType,
            selectedAccount?.partnerId,
            shoppingCart?.wifiUnitInformation.code,
        );
    }, [dataLayerErrorType, isLoggedIn, selectedAccount, shoppingCart?.wifiUnitInformation.code]);
};
